'use client';
import { useEffect, useRef } from 'react';

const personas = [
  { icon: '🛍️', title: 'Etsy Sellers', desc: 'Create listings and product ideas more efficiently with ready-made templates and printables.' },
  { icon: '📖', title: 'KDP Publishers', desc: 'Access interiors, puzzles, planners and publishing resources ready to upload to Amazon KDP.' },
  { icon: '🎨', title: 'Designers', desc: 'Use fonts, graphics, UI kits, SVGs and creative assets to accelerate your design workflow.' },
  { icon: '📱', title: 'Content Creators', desc: 'Use 100K+ photos, templates, YouTube assets and content resources to fuel your channels.' },
  { icon: '💼', title: 'Freelancers & Agencies', desc: 'Use ready-made resources as starting points for client projects where permitted by applicable license.' },
  { icon: '💻', title: 'Developers', desc: 'Explore 71 source-code projects, 145 UI resources and 153 HTML5 games to launch faster.' },
  { icon: '🏢', title: 'Small Businesses', desc: 'Access HR toolkits, spreadsheets, resume templates, productivity and business resources.' },
  { icon: '🚀', title: 'Digital Entrepreneurs', desc: 'Build a broader digital-product workflow from one comprehensive resource library.' },
];

export default function PersonasSection() {
  const itemRefs = useRef<(HTMLDivElement | null)[]>([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.remove('reveal-hidden');
            entry.target.classList.add('reveal-visible');
          }
        });
      },
      { threshold: 0.1 }
    );
    itemRefs.current.forEach((el) => { if (el) observer.observe(el); });
    return () => observer.disconnect();
  }, []);

  return (
    <section
      id="personas"
      className="relative py-20 lg:py-24"
      style={{ background: 'linear-gradient(180deg, #0B1020 0%, #080B14 100%)' }}
      aria-labelledby="personas-heading"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div
          className="text-center mb-14 reveal-hidden"
          ref={(el) => { itemRefs.current[0] = el; }}
        >
          <h2 id="personas-heading" className="section-heading mb-4" style={{ color: 'var(--foreground)' }}>
            Built for Creators Who Want to{' '}
            <span className="text-gradient">Move Faster</span>
          </h2>
          <p className="text-lg max-w-2xl mx-auto" style={{ color: 'var(--muted-foreground)' }}>
            Whether you design, publish, build, or sell — this library has something for you.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {personas.map((p, i) => (
            <div
              key={i}
              ref={(el) => { itemRefs.current[i + 1] = el; }}
              className="reveal-hidden persona-card"
              style={{ transitionDelay: `${i * 60}ms` }}
            >
              <div className="text-2xl mb-3" aria-hidden="true">{p.icon}</div>
              <h3 className="font-bold text-base mb-2" style={{ color: 'var(--foreground)' }}>{p.title}</h3>
              <p className="text-sm leading-relaxed" style={{ color: 'var(--muted-foreground)' }}>{p.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
